// ***************************************
// tgfSettings
//
// This objects contains all settings and a number of
// methods to deal with them. All the settings must be
// in sub-groups of groups of tgfSettings.
//
// Actually, you can create multiple instances of the TGFSettings
// object if you want. tgfSettings is simply the default one.
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 8-7-2015
// ***************************************
var TGFSettings = /** @class */ (function () {
    function TGFSettings() {
        this.graphics = {};
        this.graphicDefaults = {};
        this.audio = {};
        this.audioDefaults = {};
        this.statusStorage = {};
        this.status = {};
        this.gameAnalyticsConfigSettings = {};
        this.flow = {};
        this.theme = {};
        this.client = {};
        this.statusDefaults = {};
        this.storageDefaults = {};
        this.styleTranslation = {};
        this.componentDefaults = {};
        this.dialogDefaults = {};
        this.ads = {};
        this.gamebot = {};
        this.leaderboardCodes = {};
        this.whatsNewInformation = [];
        this.updateNotificationIDs = {};
        this.frameworkDefaults = {};
        this.framework = {};
        this.game = {};
        this.match = {};
        this.analytics = {};
        this.gamesparks = {};
        this.tileMapValues = {};
        this.turnDuration = {};
    }
    TGFSettings.prototype.mergeSettings = function (settings) {
        if (typeof settings !== "object") {
            return;
        }
        // Run through all the settings in the object
        for (var setting in settings) {
            if (settings.hasOwnProperty(setting)) {
                if (settings[setting] === undefined || settings[setting] === null) {
                    this[setting] = settings[setting];
                }
                else if (Object.prototype.toString.call(settings[setting]) === "[object Array]") {
                    this[setting] = settings[setting];
                }
                else if (typeof settings[setting] === "object" && settings[setting].constructor === Object) {
                    // When it is an object without its own constructor, recursively merge
                    if (typeof this[setting] !== "object") {
                        this[setting] = {};
                    }
                    this.mergeGroup(this[setting], settings[setting]);
                }
                else {
                    this[setting] = settings[setting];
                }
            }
        }
    };
    TGFSettings.prototype.mergeGroup = function (group, settings) {
        if (typeof settings !== "object") {
            return;
        }
        // Run through all the settings in the object
        for (var setting in settings) {
            if (settings.hasOwnProperty(setting)) {
                if (settings[setting] === undefined || settings[setting] === null) {
                    group[setting] = settings[setting];
                }
                else if (Object.prototype.toString.call(settings[setting]) === "[object Array]") {
                    group[setting] = settings[setting];
                }
                else if (typeof settings[setting] === "object" && settings[setting].constructor === Object) {
                    // When it is an object without its own constructor, recursively merge
                    if (typeof group[setting] !== "object") {
                        group[setting] = {};
                    }
                    this.mergeSubGroup(group[setting], settings[setting]);
                }
                else {
                    group[setting] = settings[setting];
                }
            }
        }
    };
    TGFSettings.prototype.mergeSubGroup = function (subGroup, settings) {
        if (typeof settings !== "object") {
            return;
        }
        // Run through all the settings in the object
        for (var setting in settings) {
            if (settings.hasOwnProperty(setting)) {
                subGroup[setting] = settings[setting];
            }
        }
    };
    return TGFSettings;
}());
export { TGFSettings };
export var tgfSettings = new TGFSettings();
